// utilities
import api from '@/utilities/api'
export const updateGroupSetting = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: 'private/settings/personGroups/' + payload.personGroupID,
    payload,
    success (response) {
      dispatch('getGroupSettings', payload)
    }
  })
}
export const removeGroupSetting = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/settings/personGroups/' + payload.personGroupID,
    success (response) {
      dispatch('getGroupSettings', payload)
    }
  })
}
export const getGroupSettings = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/settings/personGroups/' + payload.personGroupID,
    success (response) {
      commit('setGroupSettings', response.data)
    }
  })
}
